(function () {
  angular
    .module("akitabox.ui.dialogs.inspectionProgram.reactivate")
    .factory(
      "ReactivateInspectionProgramDialog",
      ReactivateInspectionProgramDialog
    );

  /* @ngInject */
  function ReactivateInspectionProgramDialog($log, $q, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl:
        "app/core/ui/dialogs/inspection-program/reactivate/reactivate-inspection-program.dialog.html",
      controller: "ReactivateInspectionProgramDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.inspectionProgramIDs` are required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error}               Promise that resolves with the reactivated inspectionPrograms
     */
    function show(options) {
      // Verify we have inspectionProgramIDs in locals
      if (
        !options ||
        !options.locals ||
        !options.locals.inspectionPrograms ||
        !options.locals.inspectionPrograms.length > 0
      ) {
        $log.error(
          "ReactivateInspectionProgramDialog: you must pass in InspectionProgramIDs via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
